import loadable from '@loadable/component'

const Blog = loadable(
  () => import(
    './Blog.component'
  ),
)

export default Blog
